import { FF_DATADOG_SESSION_REPLAY_SAMPLE_RATE } from './featureFlags';

/*
 * This object is used to force session replays for certain feature flags.
 *
 * The key is the feature flag name and the value either a boolean or an array of values (variants) that will force session replays.
 * The value must match the value returned by the feature flag to force session replays.
 */
const ffForceSessionReplays: Record<string, boolean | any[]> = {
  [FF_DATADOG_SESSION_REPLAY_SAMPLE_RATE]: true,
};

export default ffForceSessionReplays;
